import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Footer from "./components/Footer";
import Header from "./components/Header";
import Homepage from "./pages/Homepage";
import Contact from "./pages/Contact";
import Portfolio from "./pages/Portfolio";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <Router>
      <div>
        <Header />
        <Switch>
          <Route exact path={["/"]} component={Homepage} />
          <Route exact path={["/Homepage"]} component={Homepage} />
          <Route exact path={["/Portfolio"]} component={Portfolio} />
          <Route exact path={["/Contact"]} component={Contact} />
        </Switch>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
